import { useOutletContext } from "react-router"
import { PlaceOutletContextType } from "../home/PlacesHome"
import { useErrorBoundary } from "react-error-boundary"
import { useCallback, useContext, useEffect, useState } from "react"
import { NotificationContext } from "shared/NotificationContext"
import { AVAILABLE_RANGES, DateRange, NotificationType, PlaceDashboard } from "shared/topchef.types"
import api from 'shared/topchef-api-places';
import Loading from "pages/shared/loading/Loading"
import { formatAmount } from "shared/topchef.utils"
import SharedLeadsLoader from "../shared-leads-loader/SharedLeadsLoader"
import FollowedLeadsLoader from "../followed-leads-loader/FollowedLeadsLoader"
import LeadsToCloseLoader from "../leads-to-close-loader/LeadsToCloseLoader"

const PlaceDashboardComponent = () => {

  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();
  
  const [currentRange, setCurrentRange] = useState<DateRange>(AVAILABLE_RANGES[0])
  const [dashboardReady, setDashboardReady] = useState<boolean>(false);
  const [dashboard, setDashboard] = useState<PlaceDashboard | null>(null);
  
  const { showBoundary } = useErrorBoundary();
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;
  

  const loadDashboard = useCallback( async () => {
    setDashboardReady(false);
    try {
      const currentDashboard: PlaceDashboard = await api.loadDashboard(loggedInPlace!.id, currentRange);
      setDashboard(currentDashboard);

      setDashboardReady(true);
    } catch (error: any) { 
      const newError = new Error(`Problème pour récupérer les données de votre tableau de bord : '${error.message}'`);
      triggerNotification({type: NotificationType.error, message : newError.message});
      return showBoundary(newError);
    } 
  }, [currentRange, loggedInPlace, triggerNotification, showBoundary]);

  

  useEffect(() => {
    loadDashboard();
  }, [currentRange, loadDashboard,loggedInPlace, triggerNotification, showBoundary]);

  const changeRange = (event: React.ChangeEvent<HTMLSelectElement> ) => {
    event.preventDefault();
    const selectedValue = event.target.value;
    const selectedRange: DateRange =  AVAILABLE_RANGES.find(range => range.value === selectedValue) || {value: '', label: '', startDate : null, endDate: null}
    setCurrentRange(selectedRange);
  };


  if (!dashboardReady) {
    return (
      <Loading />
    );
  }


  return (
    <>
      <div className="page-dashboard container p-5 overflow-auto vh-100">
          <div className="dashboard-head row">
              <div id="lead_sidebar" className="d-flex">
                <ul className="nav nav-pills flex-column mb-auto">
                  <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
                </ul>
              </div>
              <h4 className="mb-3 col-md-9">Votre tableau de bord</h4>
              <div className="lochall_points col-md-3 text-end">     
                  <span className="fw-bold">Vos points EventLink : {loggedInPlace!.locHallPoints}</span>
                  <span className="lochall_points_count" ></span>
              </div>
          </div>
          <div className="row g-4">
              <div className="col-md-12">
                  <select name="global_traffic_view" onChange={changeRange} value={currentRange.value}>
                    {AVAILABLE_RANGES.map((range: DateRange) => (
                        <option key={range.value} value={range.value}>
                          {range.label}
                        </option>
                      ))}
                  </select>
              </div>
              <div className="col-md-2 w-20">
                  <div id="briefs_moving" className="card p-3 text-center">
                      <p className="fw-bold mb-2">Nombre total de briefs mis en circulation</p>
                      <h3 id="briefs_moving_count" className="mb-0">{dashboard!.briefMarketSize}</h3>
                  </div>
              </div>
              <div className="col-md-2 w-20">
                  <div id="briefs" className="card p-3 text-center">
                      <p className="fw-bold mb-2">Nombre de briefs déposés</p>
                      <h3 id="briefs_count" className="mb-0">{dashboard!.sharedLeads}</h3>
                  </div>
              </div>
              <div className="col-md-2 w-20">
                  <div id="briefs_signed" className="card p-3 text-center">
                      <p className="fw-bold mb-2">Nombre de briefs signés</p>
                      <h3 id="briefs_signed_count" className="mb-0">{dashboard!.signedLeads}</h3>
                  </div>
              </div>
              
              <div className="col-md-2 w-20">
                  <div id="event_gains" className="card p-3 text-center">
                      <p className="fw-bold mb-2">Gains générés</p>
                      <h3 id="event_gains_count" className="mb-0">{formatAmount(dashboard!.earnedFees)}</h3>
                  </div>
              </div>

          </div>
      
        <div className="mt-4">
          <SharedLeadsLoader
            title={"Vos 3 derniers briefs transmis"}
            showMenu={false}
            limit={3}
            paginateResults={false} 
            height="200px" />
        </div>

        {loggedInPlace.acceptReward &&
          <>
            <div className="mt-4">
              <FollowedLeadsLoader
                title={"Vos 3 derniers briefs à traiter"}
                showMenu={false}
                limit={3}
                paginateResults={false} 
                height="200px" />
            </div>

            <div className="mt-4 mb-4">
              <LeadsToCloseLoader 
                title={"Vos 3 derniers briefs signés à clôturer"}
                showMenu={false}
                limit={3}
                paginateResults={false} 
                height='200px'
                />
            </div>
          </>
        }
        {loggedInPlace.acceptReward === false &&
          <>
            <div className="mt-4">
              <FollowedLeadsLoader
                title={"Vos 3 derniers briefs suivis"}
                showMenu={false}
                limit={3}
                paginateResults={false} 
                height="200px" />
            </div>
          </>
        }

      </div>

    </>
  );

}

export default PlaceDashboardComponent;
